import { BRKT_TRANSACTIONS_QUERY, } from "./queries";
import type { Store } from "@bracket/platform/store";
import { API_URLS } from "@bracket/platform/constants";

export const getBrktTransactions = async (store: Store) => {
	const { address, anonymous, } = store.wallet;
	if(anonymous) {
		// return null;
	}
	const response = await fetch(API_URLS.GRAPHQL_API, {
		method: "POST",
		body: JSON.stringify({
			query: BRKT_TRANSACTIONS_QUERY,
			variables: {
				wallet: address as string,
			},
		}),
		headers: {
			"Content-Type": "application/json",
			"wallet": address as string,
		},
	});

	if(response.ok) {
		const { data, } = await response.json();
		return data.checkin.transactions;
	}
	throw new Error("Failed to fetch brkt transactions");

};


function transformScalars(obj, transformers, schema) {
  if (obj === null || obj === undefined) return obj;
  
  if (Array.isArray(obj)) {
    return obj.map(item => transformScalars(item, transformers, schema));
  }
  
  if (typeof obj === 'object') {
    return Object.entries(obj).reduce((acc, [key, value]) => {
      acc[key] = transformScalars(value, transformers, schema);
      return acc;
    }, {});
  }
  
  return obj;
}
